export const blockIconsSocialRecommendNew = (
	<span className='material-symbols-outlined'>recommend</span>
);
